import { render } from "./ContactReport.vue?vue&type=template&id=81b10fbc&scoped=true"
import script from "./ContactReport.vue?vue&type=script&lang=js"
export * from "./ContactReport.vue?vue&type=script&lang=js"

import "./ContactReport.vue?vue&type=style&index=0&id=81b10fbc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81b10fbc"],['__file',"src/views/h5/crm/report/ContactReport.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "81b10fbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('81b10fbc', __exports__)) {
    api.reload('81b10fbc', __exports__)
  }
  
  module.hot.accept("./ContactReport.vue?vue&type=template&id=81b10fbc&scoped=true", () => {
    api.rerender('81b10fbc', render)
  })

}


export default __exports__